import { Component, computed, inject, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { DropdownComponent } from '@valk-nx/components/ui-dropdown/src/lib/dropdown';
import type { DropdownOption } from '@valk-nx/components/ui-dropdown/src/lib/dropdown.interface';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';
import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

import type {
	SortOptionValue,
	SortSelection,
} from '../../contracts/filters.interface';
import { toSortSelection } from '../../contracts/filters.interface';
import { FilterSheetButtonComponent } from '../filter-sheet-button/filter-sheet-button';

export const DEFAULT_SORT_OPTIONS: (DropdownOption & {
	value: SortOptionValue;
})[] = [
	{ value: 'name-asc', label: 'global.sort.name-asc' },
	{ value: 'name-desc', label: 'global.sort.name-desc' },
	{ value: 'price-asc', label: 'global.sort.price-asc' },
	{ value: 'price-desc', label: 'global.sort.price-desc' },
];

@Component({
	selector: `vp-filter-heading`,
	templateUrl: './filter-heading.html',
	imports: [
		DropdownComponent,
		FilterSheetButtonComponent,
		SVG_ICON_IMPORTS,
		TranslatePipe,
	],
})
export class FilterHeadingComponent {
	private readonly viewport = inject(ViewPortService);

	title = input.required<string>();
	sortOptions = input<DropdownOption[]>(DEFAULT_SORT_OPTIONS);
	indicator = input<number>(0);
	numberOfResults = input<number | undefined>(undefined);

	sortChanged = output<SortSelection>();
	showMap = output<void>();

	dropdownAlignment = computed(() => {
		return this.viewport.isXxlWidth() ? 'left' : 'right';
	});

	onSortChange(value: string) {
		this.sortChanged.emit(toSortSelection(value));
	}
}
